import React from "react";
import { Button } from "@mui/material";

export default function MessageAdditionalItems({ message }) {
  const handleClick = () => {
    console.log("message clicked", message);
  };
  return <Button onClick={handleClick}>More</Button>;
}
